@if (data) {
<div class="font-poppins text-gray-800">
  <h3 class="text-lg font-bold mb-1">Inclusion Criteria</h3>
  <ul class="list-disc list-inside mb-4">
    @for (criterion of inclusionCriteria; track criterion) {
    <li class="text-gray-800 mb-2">{{ criterion }}</li>
    }
  </ul>
  <h3 class="text-lg font-bold mb-1">Exclusion Criteria</h3>
  <ul class="list-disc list-inside mb-4">
    @for (criterion of exclusionCriteria; track criterion) {
    <li class="text-gray-800 mb-2">{{ criterion }}</li>
    }
  </ul>
</div>
}